import { jsx as e } from "react/jsx-runtime";
import { toast as o, Toaster as i } from "sonner";
const n = (t, r) => {
  !t || typeof t == "string" && !t.trim() || o(t, r);
};
n.success = (t, r) => {
  !t || typeof t == "string" && !t.trim() || o.success(t, r);
};
n.error = (t, r) => {
  !t || typeof t == "string" && !t.trim() || o.error(t, r);
};
n.warning = (t, r) => {
  !t || typeof t == "string" && !t.trim() || o.warning(t, r);
};
n.info = (t, r) => {
  !t || typeof t == "string" && !t.trim() || o.info(t, r);
};
n.promise = o.promise;
const u = ({ ...t }) => /* @__PURE__ */ e(
  i,
  {
    className: "toaster group",
    toastOptions: {
      closeButton: !0,
      duration: 5e3,
      classNames: {
        success: "group-[.toaster]:bg-success-100 group-[.toaster]:text-success-800 group-[.toaster]:border-success-200 [&_.toastIcon]:hidden",
        error: "group-[.toaster]:bg-critical-100 group-[.toaster]:text-critical-800 group-[.toaster]:border-critical-200 [&_.toastIcon]:hidden",
        info: "group-[.toaster]:bg-onSurface-100 group-[.toaster]:text-onSurface-800 group-[.toaster]:border-onSurface-200 [&_.toastIcon]:hidden",
        warning: "group-[.toaster]:bg-warning-100 group-[.toaster]:text-warning-800 group-[.toaster]:border-warning-200 [&_.toastIcon]:hidden",
        icon: "toastIcon",
        toast: "group toast group-[.toaster]:shadow-lg rounded border-none pointer-events-auto after:pointer-events-none",
        title: "text-strongSmallBody ",
        description: "text-smallBody",
        closeButton: "bg-transparent border-none text-onSurface-900 left-auto right-0 top-2",
        actionButton: "group-[.toast]:bg-primary group-[.toast]:!mr-2",
        cancelButton: "group-[.toast]:bg-muted group-[.toast]:!mr-2"
      }
    },
    ...t
  }
);
export {
  u as ToastProvider,
  n as toast
};
